import type { GetOptionsType } from '@pages/Warehouses/types';

export const getOptions: GetOptionsType = (list, key = 'Id') =>
  list?.map(({ Name, ...item }) => ({ label: Name, value: item[key] })) || [];
